// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ProcedureReportProps } from '../../../../Types/LogT';
import LinkText from '../../../../Atoms/LinkText';

const PublishInvoiceReport: FC<ProcedureReportProps> = ({ report }) => {
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { entityId, executionStatus } = report ?? {};

  const onClick = () => {
    if (eventId && executionStatus === 'COMPLETED') {
      navigate(`/events/${eventId}/documents/${entityId}`);
    }
  };

  return (
    <Text>
      <LinkText span onClick={onClick} weight="bolder">
        Rechnung
      </LinkText>{' '}
      an Buchhaltung übertragen
    </Text>
  );
};

export default PublishInvoiceReport;
